
import { SuburbLookupData } from '@/models/main';
import { AddressBookData } from '@/models/addressBook';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component({})
export default class LookupSuburb extends Vue {
  @Prop({ type: Number, required: true }) private readonly stop!: number;
  @Prop({ type: Number, required: false }) private readonly shift_id!: number;
  @Prop({ type: Number, required: false }) private readonly editedItem!: number;
  @Prop({ type: Boolean, required: true }) private readonly disabled!: boolean;
  @Prop({ type: Object, required: false })
  private readonly chosen!: AddressBookData;
  @Prop({ type: Number, required: false }) private readonly tabIndex!: number;
  @Prop({ type: Function, required: true }) private autocomplete!: (params: string) => Promise<SuburbLookupData[]>;

  private loading = false;
  private inputText = '';
  private itemSearch: SuburbLookupData[] = [];
  private selectedSuburbDefault = {
    id: -1,
    name: '',
    postcode: '',
    state: '',
    zone: '',
  };
  private selectedSuburb = this.selectedSuburbDefault;

  private search(val) {
    this.inputText = val;
    if (val?.length >= 3) {
      this.itemSearch = [];
      this.loading = true;
      this.autocomplete(val)
        .then(data => {
          this.itemSearch = data;
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    }
  }

  private change() {
    if (!this.selectedSuburb) {
      this.itemSearch = [];
      this.selectedSuburb = this.selectedSuburbDefault;
      this.$emit('clear', this.shift_id ? this.shift_id : this.stop);
    } else {
      this.$emit('change', this.shift_id ? this.shift_id : this.stop, this.selectedSuburb);
    }
  }

  @Watch('chosen', { immediate: true, deep: true })
  private watchToChosen() {
    // Clear the suburb if the parent has been cleared
    if (this.chosen.suburbId === -1) {
      this.selectedSuburb = { ...this.selectedSuburbDefault };
    }
    if (
      this.chosen.suburb &&
      typeof this.chosen.suburb === 'string' &&
      this.selectedSuburb &&
      (this.chosen.suburbId !== this.selectedSuburb.id || this.chosen.suburbId === -1)
    ) {
      this.loading = true;
      this.autocomplete(this.chosen.suburb)
        .then(data => {
          this.itemSearch = data;

          let find;
          if (this.chosen.suburbId && this.chosen.suburbId >= 0) {
            find = data.find(x => x.id === this.chosen.suburbId);
          } else {
            const suburbName = String(this.chosen.suburb).toUpperCase();
            find = data.find(
              x =>
                x.name.toUpperCase() === suburbName &&
                x.state === this.chosen.state &&
                x.postcode === this.chosen.postcode,
            );
          }

          if (find) {
            this.selectedSuburb = find;
            // maybe better to add 'suburb_id' to the backend ?
            this.$emit('change', this.stop, this.selectedSuburb);
          } else if (data.length === 1) {
            // Auto-select if there's only one result
            this.selectedSuburb = data[0];
            this.$emit('change', this.stop, this.selectedSuburb);
          }
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    } else if (this.itemSearch.length >= 1 && this.editedItem === -1 && this.chosen.suburbId === -1) {
      this.itemSearch = [];
    }
  }
}
